import Vue from 'vue';

document.addEventListener('DOMContentLoaded', () => {
  const worldMenuMobile = document.getElementById('js-world-menu-mobile');

  if (worldMenuMobile) {
    const vm = new Vue({
      delimiters: ['${', '}'],
      el: worldMenuMobile,
      data: {
        isOpen: false,
      },
      methods: {
        toggleWorldMenuMobile() {
          if (!this.isOpen) {
            this.openWorldMenuMobile();
          } else {
            this.closeWorldMenuMobile();
          }
        },
        openWorldMenuMobile() {
          this.isOpen = true;
          document.addEventListener('keydown', this.handleEsc);
          document.addEventListener('click', this.handleClickOutside);
        },
        closeWorldMenuMobile() {
          document.removeEventListener('keydown', this.handleEsc);
          document.removeEventListener('click', this.handleClickOutside);
          this.isOpen = false;
        },
        handleEsc(e) {
          if (e.keyCode === 27) {
            this.closeworldMenuMobile();
          }
        },
        handleClickOutside(e) {
          const isClickInside = this.$el.contains(e.target);

          if (!isClickInside) {
            this.closeworldMenuMobile();
          }
        },
      },
    });
  }
});
